import React from "react"
import {Link} from "react-router-dom"
import Hero from './Hero'
import styles from './Welcome.module.scss'

export default function Welcome(props) {
    return (
        <>
            <Hero/>
            <hr className={styles.divider}/>
            <div className={styles.story}>
                <p>
                    That includes the infrastructure side, not just the code. This site runs on hardware I set up
                    and maintain myself CI/CD, containers, TLS. <Link className={styles.inlineLink} to="/infrastructure/behind-this-site"
                                         onClick={() => props.selectPages('pages')}>Behind this site</Link> has
                    the full technical story, if you're curious.
                </p>
                <p>
                </p>
            </div>
        </>
    )
}
